import Product from './DictionaryOfPermission/Product';
import Dashboard from './DictionaryOfPermission/Dashboard';
import ProductDetail from './DictionaryOfPermission/ProductDetail';
import CompareProduct from './DictionaryOfPermission/CompareProduct'
import BOM from './DictionaryOfPermission/BOM';
import Alerts from './DictionaryOfPermission/Alerts';
import Checkout from './DictionaryOfPermission/Checkout';
import Forecast from "./DictionaryOfPermission/Forecast";
import Order from "./DictionaryOfPermission/Order";
import Quote from './DictionaryOfPermission/Quote';

class ZuPurchaseManager {

    static register = {
        ...Dashboard.register,
        ...Forecast.register,
        ...Product.register,
        ...ProductDetail.register,
        ...CompareProduct.register,
        ...BOM.register,
        ...Alerts.register,
        ...Checkout.register,
        ...{ [Checkout.register_internal.CHECKOUT_PLACE_ORDER_BUTTON.slug]: Checkout.register_internal.CHECKOUT_PLACE_ORDER_BUTTON },
        ...Order.register,
        ...Quote.register,
        ...{ [BOM.register_external.DOWNLOAD_BOM.slug]: BOM.register_external.DOWNLOAD_BOM }
    };

    static avUserInfoName = 'ZU';

}

export default ZuPurchaseManager;